import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { Link } from "@root/shared/components/Link";
import { PickupButton } from "@clientFrontend/features/scout/components/UserDetailModal/uiParts/PickupButton";
import * as styles from "./styles.css";

export type scoutButtonContentProps = {
  scoutUrl: string;
  premiumScoutUrl: string;
};

export type PickupButtonContentProps = {
  isPickedUp: boolean;
  loading: boolean;
  onClickPickup: () => void;
};

type Props = {
  isShowScoutButton: boolean;
  displayControlInformation: {
    isHideInfo?: boolean;
    hideInfoReasonText?: string;
    notScoutableReasonText?: string;
    isNotScoutable: boolean;
    scoutIndexUrl?: string;
    isNew: boolean;
    entryText?: string;
    isIconFire: boolean;
  };
  sexAndAgeText: string;
  scoutButtonContent: scoutButtonContentProps;
  pickupButtonContent?: PickupButtonContentProps;
  scoutGaEvents: {
    gaAction: string;
    gaLabel: string;
  };
  premiumScoutGaEvents: {
    gaAction: string;
    gaLabel: string;
  };
  pickupGaEvents: {
    gaAction: string;
    gaLabel: string;
  };
  pickupReleaseGaEvents: {
    gaAction: string;
    gaLabel: string;
  };
};

export const Header: FC<Props> = ({
  isShowScoutButton,
  displayControlInformation: { isNew, entryText, isNotScoutable },
  sexAndAgeText,
  scoutButtonContent,
  pickupButtonContent,
  scoutGaEvents,
  premiumScoutGaEvents,
  pickupGaEvents,
  pickupReleaseGaEvents,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerInner}>
        <div className={styles.headerContainer}>
          <Heading tag="p" size="medium" bold>
            {isNew && <span className="p-scout-label p-scout-label--new mr_10 mt_0">new</span>}
            {entryText && (
              <span className="p-scout-label p-scout-label--grey mr_10 mt_0">{entryText}</span>
            )}
            {sexAndAgeText}
          </Heading>
          <div className={styles.buttonContainer}>
            {isShowScoutButton && !isNotScoutable && (
              <>
                <Link
                  className={styles.buttonSmall}
                  theme="secondary"
                  href={scoutButtonContent.scoutUrl}
                  data-ga-label={scoutGaEvents.gaLabel}
                  data-ga-action={scoutGaEvents.gaAction}
                >
                  スカウト
                </Link>
                <Link
                  className={styles.buttonMedium}
                  theme="primary"
                  href={scoutButtonContent.premiumScoutUrl}
                  data-ga-label={premiumScoutGaEvents.gaLabel}
                  data-ga-action={premiumScoutGaEvents.gaAction}
                >
                  プレミアムスカウト
                </Link>
              </>
            )}
            {pickupButtonContent && (
              <PickupButton
                pickupButtonContent={pickupButtonContent}
                pickupGaEvents={pickupGaEvents}
                pickupReleaseGaEvents={pickupReleaseGaEvents}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
